"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizePrivacyPolicyUrl = exports.PRIVACY_POLICY_URL_MAX_LENGTH = void 0;
/**
 * The account's link to its privacy policy, shown on the pages behind the
 * Refuse email tracking link and on the preferences page, as "Read more about
 * how we use email tracking" (the regulators ask for a link to detailed
 * information next to the short notice). No imports, so the pages and the
 * server use the same check.
 *
 * A link on a public page is shown to people the account emails, so only a
 * plain web address is accepted: http or https, no sign-in details in it, no
 * spaces or control characters, and not longer than a browser handles.
 */
exports.PRIVACY_POLICY_URL_MAX_LENGTH = 2000;
/**
 * The address to link to, in the form a browser writes it, or undefined when
 * the value is not an address the pages may link to. Never throws.
 */
const normalizePrivacyPolicyUrl = (value) => {
    if (typeof value !== "string")
        return undefined;
    const text = value.trim();
    if (!text || text.length > exports.PRIVACY_POLICY_URL_MAX_LENGTH)
        return undefined;
    // eslint-disable-next-line no-control-regex
    if (/[\s\u0000-\u001f\u007f]/.test(text))
        return undefined;
    try {
        const url = new URL(text);
        if (url.protocol !== "https:" && url.protocol !== "http:")
            return undefined;
        if (!url.hostname)
            return undefined;
        if (url.username || url.password)
            return undefined;
        return url.href;
    }
    catch (e) {
        return undefined;
    }
};
exports.normalizePrivacyPolicyUrl = normalizePrivacyPolicyUrl;
//# sourceMappingURL=privacy_policy_url.js.map